import type { Type } from '@angular/core';
import { ContentChild, Directive, inject } from '@angular/core';

import { EmptyStateDefaultComponent } from './empty-state-default.component';
import { Select2EmptyStateDirective } from './empty-state.directive';
import { TemplateResolver } from '../../utils/template-resolver';

@Directive({
  standalone: true,
  selector: 'rt-select2-empty-state-resolver',
})
export class EmptyStateResolverDirective extends TemplateResolver<
  Select2EmptyStateDirective,
  { optional: true }
> {
  @ContentChild(Select2EmptyStateDirective)
  public override contentDirective?: Select2EmptyStateDirective;
  public override injectedComponent = <Type<EmptyStateDefaultComponent>>(
    (<unknown>inject(EmptyStateDefaultComponent, { optional: true }))
  );
  public override defaultComponent = null;
}
